import { useTranslation } from 'next-i18next';
import Link from 'next/link';

import Avatar from 'components/Avatar';
import { ButtonV3 } from 'components/ComponentV2';
import { useResponsive } from 'hooks/useResponsive';
import { TBasicStudentSociety } from 'lib/models/student-society';
import { PAGE_ROUTES } from 'lib/page-routes';

import styles from './CommunityCard.module.scss';

type CommunityCardProps = {
  community: TBasicStudentSociety;
};

const CommunityCard: React.FC<CommunityCardProps> = ({ community }) => {
  const screens = useResponsive();
  const [tCommon] = useTranslation('common');
  const { name, icon_url, university_name, slug } = community;
  const route = PAGE_ROUTES.SOCIETY_PUBLIC.replace('[slug]', slug);

  const content = (
    <section className={styles.container}>
      <Avatar icon={icon_url} name={name} className={styles.image} size={'40'} />
      <div className={styles.names}>
        <label title={name} className={styles.name}>
          {name}
        </label>
        <label title={university_name} className={styles['sub-name']}>
          {university_name}
        </label>
      </div>
      <a href={route} target="_blank" className={styles.link} rel="noreferrer">
        <ButtonV3 color="secondary" isFullWidth className={styles.button}>
          {tCommon('view')}
        </ButtonV3>
      </a>
    </section>
  );

  return screens.sm ? (
    <Link href={route} passHref>
      <a>{content}</a>
    </Link>
  ) : (
    content
  );
};

CommunityCard.displayName = 'CommunityCard';

export default CommunityCard;
